//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// page
import MyEditDetail from "./components/MyEditDetail";

// component
import DefaultModal from "../../../component/popup/DefaultModal";
import BasicBtn from "../../../component/button/BasicBtn";

// responsive
import { M, T } from "../../../utils/MT";

export default function MyEditDetailPage() {
    //페이지 이동
    const navigate = useNavigate();
    const MyEdit = () => {
        navigate(-1);
    };

    // 1. 등록되지않은 추천인 모달
    const [noMember, setNoMember] = useState(false);
    // 2. 수정 완료 모달
    const [complModal, setComplModal] = useState(false);

    // 1. 등록되지않은 추천인 모달
    const NoMemberCon = () => {
        return (
            <SmallModalBox>
                <ConTitle>등록되지않은 추천인 ID 입니다.</ConTitle>
                <BtnSmallWrap>
                    <BasicBtn text="닫기" gray={true} black={true} onClick={() => setComplModal(false)} />
                </BtnSmallWrap>
            </SmallModalBox>
        );
    };

    // 2. 수정 완료 모달
    const CompledModalCon = () => {
        return (
            <SmallModalBox>
                <ConTitle>본인정보 수정이 완료되었습니다.</ConTitle>
                <BtnSmallWrap>
                    <BasicBtn
                        text="닫기"
                        gray={true}
                        black={true}
                        onClick={() => {
                            setNoMember(false);
                            MyEdit();
                        }}
                    />
                </BtnSmallWrap>
            </SmallModalBox>
        );
    };

    return (
        <>
            <MyEditDetail setNoMember={setNoMember} setComplModal={setComplModal} />

            {/* 모달 */}
            {/* 1. 등록되지않은 추천인 모달 */}
            {noMember && <DefaultModal closeModal={() => setNoMember(false)} contents={NoMemberCon} />}
            {/* 2. 수정 완료 모달 */}
            {complModal && <DefaultModal closeModal={() => setComplModal(false)} contents={CompledModalCon} />}
        </>
    );
}

// 팝업 스타일링
const SmallModalBox = styled.div`
    width: calc(100vw * (200 / 1920));

    text-align: center;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (200 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
    }
`;
const ConTitle = styled.div`
    font-size: calc(100vw * (15 / 1920));

    margin-bottom: calc(100vw * (9 / 1920));
    white-space: nowrap;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
        margin-bottom: calc(100vw * (9 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};
        margin-bottom: ${M(9)};
    }
`;

const BtnSmallWrap = styled.div`
    width: calc(100vw * (100 / 1920));
    margin: 0 auto;

    margin-top: calc(100vw * (14 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (100 / 1300));
        margin-top: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(100)};
        margin-top: ${M(14)};
    }
`;
